import { useMutation } from "@apollo/client";

import { AddGoalMutation, AddGoalMutationVariables } from "@ctypes";
import { ADD_GOAL, USER } from "@graphql";

export const useAddGoal = () => {
  return useMutation<AddGoalMutation, AddGoalMutationVariables>(ADD_GOAL, {
    refetchQueries: [{ query: USER }],
    awaitRefetchQueries: true,
  });
};
